import Jounrey from "./Journey";

export default Jounrey;
